import React, { createRef, useEffect, useRef, useState } from 'react'
import * as routeLink from "../../constants/routeLink";

import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addRef, backup, balanceWallet, claim, deposit, getUser, ShowBlance, swap, withdraw } from '../../services/services';
import { setUser } from '../../actions/apiIndex';
import Loading from "../../components/Loading/index";
import Modal from "../../components/Modal/index";
import { ToastContainer, toast } from 'react-toastify';

const Index = (props) => {
  const { apiReducer } = useSelector((state) => state);
  const { user } = apiReducer;
  const [isHidden, setIsHidden] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModalbackup, setShowModalBackup] = useState(false);
  const [showModalDeposit, setShowModalDeposit] = useState(false);

  const [isLoading, setIsLoading] = useState(0);

  const [balanceWallet_, setbalanceWallet_] = useState(null);
  const [privkey, setPrivkey] = useState(null);


  useEffect(() => {
    const getbalanceWallet = async () => {
      const res = await balanceWallet();
      if (res.code == 200) {
        setbalanceWallet_(res.data);
      }
    }
    getbalanceWallet();
    return () => {

    };
  }, []);
  const handleToggle = () => {
    setIsHidden(!isHidden);
  };

  const [tab, setTab] = useState(1);
  const swap_ = async () => {
    setIsLoading(1);
    const res = await swap();
    if (res.message) {
      toast(res.message)
    }
    setIsLoading(0);

  }

  const inputRef = useRef(null);
  const withdraw_ = async () => {

    const amount = inputRef.current.value;

    if (amount > 0) {
      setIsLoading(2);
      const res = await withdraw(amount);
      if (res.message) {
        toast(res.message)
   
      }
      setIsLoading(0);
    }
    setShowModal(false);

  }

  const backup_ = async () => {
    setIsLoading(3);
    const res = await backup();


    if (res.code == 200) {
      if (res.data?.privkey) {
        setShowModalBackup(true)
        setPrivkey(res.data?.privkey);
      } else {
        if (res.message) {
          toast(res.message)
          
        }
      }

    }
    else {
      if (res.message) {
        toast(res.message)
      }
    }
    setIsLoading(0);

  }
  const inputRef1 = useRef(null);
  const handleCopy = (type) => {
    if (type == 1) {
      if (inputRef.current) {
        inputRef.current.select(); // Chọn toàn bộ nội dung trong input
        document.execCommand('copy'); // Sao chép nội dung đã chọn vào clipboard

        // Hiển thị thông báo hoặc thay đổi nội dung nút để thông báo đã sao chép
        alert('Copied to clipboard');
      }
    } else {
      if (inputRef1.current) {
        inputRef1.current.select(); // Chọn toàn bộ nội dung trong input
        document.execCommand('copy'); // Sao chép nội dung đã chọn vào clipboard

        // Hiển thị thông báo hoặc thay đổi nội dung nút để thông báo đã sao chép
        alert('Copied to clipboard');
      }
    }
    setShowModalBackup(false)
  };



  const inputRef2 = useRef(null);
  const deposit_ = async () => {

    const amount = inputRef2.current.value;
    
    if (amount > 0) {
      setIsLoading(4);
      const res = await deposit(amount);
      if (res.message) {
        alert(res.message)
      }
      setIsLoading(0);
    }
    setShowModalDeposit(false)


  }

  const setAllBalance=(type)=>{
    // alert(user.balanceUsdt)
    if(type==1){
      inputRef.current.value= parseInt(user.balanceUsdt)
    }
    if(type==2){
      inputRef2.current.value=parseInt(user.balanceUsdt)
    }
  }
  return (
    <div className="main main-chart  w-100 show-nav  banner">
      <div className="top-wallet  bg primary ">
        <div className="container-custom  d-flex justify-content-center flex-column align-items-center ">
          <div className="row w-100  d-flex justify-content-center  align-items-center">
            <div className="col-6 col-sm-6 col-md-6 col-lg-6 d-flex justify-content-start flex-column align-items-start pt-2">
              <p className="text-white fs-6 fw-bold p-0">Total Assets (USDT)</p>
              <p className="text-white fs-2 p-0"> {isHidden ? '*'.repeat(Number(ShowBlance(user, 2)).toFixed(2).toString().length) : Number(ShowBlance(user, 2)).toFixed(2)}</p>
            </div>

            <div className="col-6  col-sm-6 col-md-6 col-lg-6 d-flex justify-content-end flex-column align-items-end ">
              <button className="bg-unset border-unset text-white fs-5" onClick={handleToggle}>
                <i className="fas fa-eye"></i>
                <span>Hide balance</span>
              </button>
            </div>

          </div>
        </div>
      </div>
      <div className="top-wallet  bgSecondary4-2 ">
        <div className="container-custom  d-flex justify-content-center flex-column align-items-center ">
          <div className="tab d-flex justify-content-start align-items-start w-100">
            <button
              className={`button  d-flex justify-content-center align-items-center text-white px-3 py-2 ${tab == 1 ? "active" : ""}`} onClick={() => setTab(1)}>Main wallet</button>
            <button className={`button  d-flex justify-content-center align-items-center text-white px-3 py-2 ${tab == 2 ? "active" : ""}`} onClick={() => setTab(2)}>Exchange wallet</button>
          </div>
        </div>
      </div>
      <div className="container-custom h-100 d-flex justify-content-center align-items-center ">
        {tab == 2 && <div className="row w-100  ">

          <div className="col-sm-12 col-md-12 col-lg-12  mt-5  d-flex justify-content-center align-items-center">
            <div className="row w-100">
              <div className="col-sm-6 col-md-6 col-lg-6 col-6   d-flex justify-content-center align-items-center ">

                <div
                  className="card-custom d-flex flex-column justify-content-center align-items-center borderSecondary2  bg-cover radius-primary py-4 w-100"
                  style={{ backgroundImage: `url(${routeLink.domain}/assets/imgs/winbanner.0ab8f9f4.png)` }}>
                  <div className="w-80 d-flex flex-column justify-content-center align-items-center ">
                    <span className="wallet-account-title fs-4 fw-bold">Balance NTX</span>
                    {/* {JSON.stringify(user)} */}
                    <span className="text-white fs-3">{Number(ShowBlance(user, 1)).toFixed(2)}</span>
                    <button className="button primary btnMainBorder w-100" onClick={swap_}>
                      <svg data-v-a30c08c2="" xmlns="http://www.w3.org/2000/svg" width="21.981" height="21.986"
                        viewBox="0 0 21.981 21.986">
                        <g data-v-a30c08c2="" id="conversion" transform="translate(21.981 10.993) rotate(135)">
                          <path data-v-a30c08c2="" id="Path_26243" data-name="Path 26243"
                            d="M14.571,6.8H.971A.918.918,0,0,1,0,5.829a.918.918,0,0,1,.971-.971H12.24L9.034,1.651a.939.939,0,0,1,0-1.36.939.939,0,0,1,1.36,0l4.857,4.857a.887.887,0,0,1,.194,1.069A.934.934,0,0,1,14.571,6.8Z"
                            transform="translate(0 0)" className="color-icon-exchange-wallet"></path>
                          <path data-v-a30c08c2="" id="Path_26244" data-name="Path 26244"
                            d="M5.828,15.8a.882.882,0,0,1-.68-.291L.291,10.651A.887.887,0,0,1,.1,9.583.934.934,0,0,1,.971,9h13.6a.918.918,0,0,1,.971.971.918.918,0,0,1-.971.971H3.3l3.206,3.206a.939.939,0,0,1,0,1.36A.882.882,0,0,1,5.828,15.8Z"
                            transform="translate(0 -0.257)" className="color-icon-exchange-wallet"></path>
                        </g>
                      </svg>
                      <span className="ms-2 me-2">swap</span>
                      {isLoading == 1 && <Loading style={{ width: "20px", height: "20px" }} />}
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6   col-6 ">
                <div
                  className="card-custom d-flex flex-column justify-content-center align-items-center borderSecondary2  bg-cover radius-primary py-4"
                  style={{ backgroundImage: `url(${routeLink.domain}/assets/imgs/winbanner.0ab8f9f4.png)` }}>
                  <div className="w-80 d-flex flex-column justify-content-center align-items-center ">
                    <span className="wallet-account-title fs-4 fw-bold">Balance USDT</span>
                    <span className="text-white fs-3">{Number(ShowBlance(user, 2)).toFixed(2)}</span>
                    <button className="button primary btnMainBorder w-100" onClick={() => { setShowModal(true) }}>
                      <svg data-v-a30c08c2="" xmlns="http://www.w3.org/2000/svg" width="17.795" height="18.488"
                        viewBox="0 0 17.795 18.488">
                        <g data-v-a30c08c2="" id="refresh-01" transform="translate(-1 0.081)">
                          <path data-v-a30c08c2="" id="Path_26259" data-name="Path 26259"
                            d="M18.8,7.366,17.555-.081,14.993,2.481a8.8,8.8,0,1,0,2.9,10.641.8.8,0,0,0-1.468-.642,7.215,7.215,0,1,1-2.573-8.854l-2.5,2.5Z"
                            className="color-icon-exchange-wallet"></path>
                        </g>
                      </svg>
                      <span className="ms-2 me-2">withdraw</span>
                      {/* <Loading style={{ width: "20px", height: "20px" }} /> */}
                      {isLoading == 2 && <Loading style={{ width: "20px", height: "20px" }} />}
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>
          {/* <div className="col-sm-12 col-md-12 col-lg-12   mt-5">
            <p className="text-white fs-4">Lịch sử giao dịch</p>
            <div className="bg-unset border-unset text-white fs-5 ">
              <div className="card-custom borderSecondary2 bgSecondary4 ">

                <div className="card-body p-3 d-flex justify-content-center align-items-center">
                  <span className="text-white fs-6">Không có dữ liệu</span>
                </div>
              </div>
            </div>
          </div> */}


        </div>}
        {/* {JSON.stringify(user)} */}
        {tab == 1 && <div className="row w-100 ">

          <div className="col-sm-12 col-md-12 col-lg-12  mt-5  d-flex justify-content-center align-items-center">
            <div className="row w-100">
              <div className="col-sm-12 col-md-12 col-lg-6 col-6   d-flex justify-content-center align-items-center ">

                <div
                  className="card-custom d-flex flex-column justify-content-center align-items-center borderSecondary2  bg-cover radius-primary py-4 w-100"
                  style={{ backgroundImage: `url(${routeLink.domain}/assets/imgs/winbanner.0ab8f9f4.png)` }}>
                  <div className="w-80 d-flex flex-column justify-content-center align-items-center ">
                    <span className="wallet-account-title fs-4 fw-bold">Balance BNB</span>
                    <span className="text-white fs-3">{Number(balanceWallet_?.bnb ?? 0).toFixed(6) ?? 0}</span>
                    <button className="button primary btnMainBorder w-100" onClick={() => backup_(true)}>
                      <svg data-v-a30c08c2="" xmlns="http://www.w3.org/2000/svg" width="21.981" height="21.986"
                        viewBox="0 0 21.981 21.986">
                        <g data-v-a30c08c2="" id="conversion" transform="translate(21.981 10.993) rotate(135)">
                          <path data-v-a30c08c2="" id="Path_26243" data-name="Path 26243"
                            d="M14.571,6.8H.971A.918.918,0,0,1,0,5.829a.918.918,0,0,1,.971-.971H12.24L9.034,1.651a.939.939,0,0,1,0-1.36.939.939,0,0,1,1.36,0l4.857,4.857a.887.887,0,0,1,.194,1.069A.934.934,0,0,1,14.571,6.8Z"
                            transform="translate(0 0)" className="color-icon-exchange-wallet"></path>
                          <path data-v-a30c08c2="" id="Path_26244" data-name="Path 26244"
                            d="M5.828,15.8a.882.882,0,0,1-.68-.291L.291,10.651A.887.887,0,0,1,.1,9.583.934.934,0,0,1,.971,9h13.6a.918.918,0,0,1,.971.971.918.918,0,0,1-.971.971H3.3l3.206,3.206a.939.939,0,0,1,0,1.36A.882.882,0,0,1,5.828,15.8Z"
                            transform="translate(0 -0.257)" className="color-icon-exchange-wallet"></path>
                        </g>
                      </svg>
                      <span>Backup</span>
                      {isLoading == 3 && <Loading style={{ width: "20px", height: "20px" }} />}
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-6   col-6">
                <div
                  className="card-custom d-flex flex-column justify-content-center align-items-center borderSecondary2  bg-cover radius-primary py-4"
                  style={{ backgroundImage: `url(${routeLink.domain}/assets/imgs/winbanner.0ab8f9f4.png)` }}>
                  <div className="w-80 d-flex flex-column justify-content-center align-items-center ">
                    <span className="wallet-account-title fs-4 fw-bold">Balance USDT</span>
                    <span className="text-white fs-3">{Number(balanceWallet_?.usdt ?? 0).toFixed(2)}</span>
                    <button className="button primary btnMainBorder w-100" onClick={() => setShowModalDeposit(true)}>
                      <svg data-v-a30c08c2="" xmlns="http://www.w3.org/2000/svg" width="17.795" height="18.488"
                        viewBox="0 0 17.795 18.488">
                        <g data-v-a30c08c2="" id="refresh-01" transform="translate(-1 0.081)">
                          <path data-v-a30c08c2="" id="Path_26259" data-name="Path 26259"
                            d="M18.8,7.366,17.555-.081,14.993,2.481a8.8,8.8,0,1,0,2.9,10.641.8.8,0,0,0-1.468-.642,7.215,7.215,0,1,1-2.573-8.854l-2.5,2.5Z"
                            className="color-icon-exchange-wallet"></path>
                        </g>
                      </svg>
                      <span className="ms-2">Deposit</span>
                      {isLoading == 4 && <Loading style={{ width: "20px", height: "20px" }} />}

                    </button>
                  </div>
                </div>

              </div>
              <div className='col-sm-12 col-md-12 col-lg-12   col-12'>
                <div style={{ padding: '20px', color: '#fff' }}>
                  <div>Network</div>
                  <div>
                    <b>BSC</b> BNB Smart Chain (BEP20)
                  </div>
                  <div style={{ height: '20px' }}></div>
                  <div className='mb-2'>Deposit address</div>
                  <div style={{ overflowWrap: 'break-word', marginBottom: 8 }} onClick={() => {
                    navigator.clipboard.writeText(user?.address).then(() => {
                      alert('Text copied to clipboard!');
                    }).catch((err) => {
                      console.error('Failed to copy text: ', err);
                    });
                  }}>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 25 25"
                      fill="#0052ff"
                      style={{ marginBottom: '5px', marginLeft: '5px' }}
                    >
                      <path d="M16.5 13.094v4.2c0 3.5-1.4 4.9-4.9 4.9H7.4c-3.5 0-4.9-1.4-4.9-4.9v-4.2c0-3.5 1.4-4.9 4.9-4.9h4.2c3.5 0 4.9 1.4 4.9 4.9z"></path>
                      <path
                        opacity="0.4"
                        d="M17.6 2.194h-4.2c-3.45 0-4.85 1.37-4.89 4.75h3.09c4.2 0 6.15 1.95 6.15 6.15v3.09c3.38-.04 4.75-1.44 4.75-4.89v-4.2c0-3.5-1.4-4.9-4.9-4.9z"
                      ></path>
                    </svg>
                    <span>{user?.address?.slice(0, 10)}...{user?.address?.slice(-10)}</span>
                  </div>
                  <div className="img_" style={{ maxWidth: '300px', margin: 'auto', textAlign: 'center' }}>
                    <img
                      src={`https://quickchart.io/qr?text=${user?.address}&size=360`}
                      alt=""
                      style={{ width: '80%', height: '80%' }}
                    />
                  </div>
                  <div style={{ height: '20px' }}></div>
                  <div>Note: Please transfer BNB or USDT to the wallet address above!!</div>
                </div>
              </div>
            </div>

          </div>
          {/* <div className="col-sm-12 col-md-12 col-lg-12   mt-5">
            <p className="text-white fs-4">Lịch sử giao dịch</p>
            <div className="bg-unset border-unset text-white fs-5 ">
              <div className="card-custom borderSecondary2 bgSecondary4 ">

                <div className="card-body p-3 d-flex justify-content-center align-items-center">
                  <span className="text-white fs-6">Không có dữ liệu</span>
                </div>
              </div>
            </div>
          </div> */}


        </div>}
        {/* <div className="row w-100 ">
       
        <div className="col-sm-12 col-md-12 col-lg-12  mt-5">
          <div className="col-sm-12 col-md-12 col-lg-6">
            <div className="bg-unset border-unset text-white fs-5 ">
              <div className="card-custom borderSecondary2 bgSecondary4 ">
                <div className="card-top d-flex justify-content-between align-items-center borderBtSecondary3 p-3">
                  <div className="d-flex">
                    <div className="me-2">
                      <div> <img src="./statics/images/icon-usdt.f667059b.svg" alt=""/></div>
                    </div>
                    <div className="d-flex flex-column">
                      <span className="text-white fs-6 fw-bold">USDT</span>
                      <span className="colorSecondary2 fs-6">Tether</span>
                    </div>
                  </div>
                  <div className="d-flex flex-column">
                    <div className="d-flex justify-content-end align-items-center">
                      <span className="text-white fs-6 fw-bold text-end">0</span>
                    </div>
                    <div className="d-flex justify-content-end align-items-center ">
                      <span className="colorSecondary2 fs-6">$0</span>
                    </div>
                  </div>
                </div>
                <div className="card-body p-3 d-flex">
                  <div className="d-flex w-50 justify-content-center align-items-center">
                    <button className="bg-unset border-unset">
                      <img src="./statics/images/icon-deposit.afd6195e.svg" alt="" />
                      <span className="text-white fs-6">Nạp tiền</span>
                    </button>
                  </div>
                  <div className="d-flex w-50  justify-content-center align-items-center">
                    <button className="bg-unset border-unset">
                      <img src="./statics/images/icon-withdraw.bc763a24.svg" alt="" />
                      <span className="text-white fs-6">Rút tiền</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-6 ">


          </div>
        </div>
        <div className="col-sm-12 col-md-12 col-lg-12   mt-5">
          <p className="text-white fs-4">Lịch sử giao dịch</p>
          <div className="bg-unset border-unset text-white fs-5 ">
            <div className="card-custom borderSecondary2 bgSecondary4 ">
              <div className="card-top d-flex justify-content-between align-items-center borderBtSecondary3 ">
                <div className="tab d-flex justify-content-start align-items-start w-100">
                  <button
                    className="button  active d-flex justify-content-center align-items-center text-white px-3 py-2">USDT</button>
                  <button
                    className="button  d-flex justify-content-center align-items-center text-white px-3  py-2">Hoa
                    hồng</button>
                </div>
              </div>
              <div className="card-body p-3 d-flex justify-content-center align-items-center">
                <span className="text-white fs-6">Không có dữ liệu</span>
              </div>
            </div>
          </div>
        </div>


      </div> */}
      </div>
      <div className="tab d-flex justify-content-start align-items-start w-100">

      </div>
      <Modal show={showModalbackup} setHide={setShowModalBackup} >

        <div class="modal-exchange bg-body position-relative h-50">


          <div class="modal-exchange-top d-flex bgSecondary4 w-100 d-none">
            <div
              class="d-flex justify-content-center align-items-center flex-column  w-50 position-relative boder-right-main p-4 ">
              <div class="d-flex justify-content-center align-items-center">
                <span class="colorPrimary fs-4">USD</span>
                <span class="text-white ms-1">wallet</span>
              </div>
              <div>
                <span class="text-white fs-3">0</span>
              </div>


              <button class="btn-exchange bg-unset border-unset position-absolute"><svg xmlns="http://www.w3.org/2000/svg"
                width="30" height="30" viewBox="0 0 30 30" class="iconTransfer">
                <g id="Group_10897" data-name="Group 10897" transform="translate(-559.431 -202.553)">
                  <g id="Group_4613" data-name="Group 4613" transform="translate(559.431 202.553)">
                    <g id="Rectangle_2919" data-name="Rectangle 2919" transform="translate(0)" fill="#e9f0fa"
                      stroke="#e5e5e5" stroke-width="1">
                      <rect width="30" height="30" rx="15" stroke="none"></rect>
                      <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" fill="none"></rect>
                    </g>
                  </g>
                  <g id="conversion" transform="translate(567.976 210.905)">
                    <path id="Path_13963" data-name="Path 13963"
                      d="M13.474,6.51H1V5.376H12.1l-3.4-3.4.8-.8,4.37,4.37a.567.567,0,0,1-.4.968Z"
                      transform="translate(-1 -1.172)" fill="#031219"></path>
                    <path id="Path_13964" data-name="Path 13964"
                      d="M5.536,33.338l-4.37-4.37a.567.567,0,0,1,.4-.968H14.041v1.134H2.936l3.4,3.4Z"
                      transform="translate(-1 -20.395)" fill="#031219"></path>
                  </g>
                </g>
              </svg></button>
            </div>

            <div class="d-flex justify-content-center align-items-center flex-column  w-50">

              <div>
                <span class="text-white">Licve Account</span>

              </div>
              <div>
                <span class="text-white fs-3">0</span>
              </div>
            </div>
          </div>
          <div class="modal-exchange-body hidden-desktop">

            <div class="content d-flex flex-column align-items-center  px-3 py-5 w-100">
              <div className="col-lg-12 w-100">
                <p className="font-14 color-light-gray colorSecondary2 mb-2 label">

                  Registration link</p>
                <div className="inputGroup mb-3 position-relative">
                  <input ref={inputRef1} readOnly="readOnly" type="text" aria-label="Recipient's username"
                    aria-describedby="button-addon2" className="form-control w-100" value={privkey} />
                  <div className="input-append d-flex align-items-center h-100">
                    <button type="button" id="button-addon2" className="btn button primary" onClick={() => handleCopy(2)}>Copy</button>
                  </div>
                </div>


              </div>
            </div>
          </div>

        </div>
      </Modal>
      <Modal show={showModal} setHide={setShowModal} >

        <div class="modal-exchange bg-body position-relative h-50 ">

          {/* <div class="modal-title d-flex justify-content-between align-items-center px-2 py-2 hidden-desktop">
            <h1 class="text-white">Chuyển tiền</h1>
            <button class="bg-unset border-unset"><i class="fas fa-times text-white"></i></button>
          </div> */}
          <div class="modal-exchange-top d-flex bgSecondary4 w-100 d-none">
            <div
              class="d-flex justify-content-center align-items-center flex-column  w-50 position-relative boder-right-main p-4 ">
              <div class="d-flex justify-content-center align-items-center">
                <span class="colorPrimary fs-4">USD</span>
                <span class="text-white ms-1">wallet</span>
              </div>
              <div>
                <span class="text-white fs-3">0</span>
              </div>


              <button class="btn-exchange bg-unset border-unset position-absolute"><svg xmlns="http://www.w3.org/2000/svg"
                width="30" height="30" viewBox="0 0 30 30" class="iconTransfer">
                <g id="Group_10897" data-name="Group 10897" transform="translate(-559.431 -202.553)">
                  <g id="Group_4613" data-name="Group 4613" transform="translate(559.431 202.553)">
                    <g id="Rectangle_2919" data-name="Rectangle 2919" transform="translate(0)" fill="#e9f0fa"
                      stroke="#e5e5e5" stroke-width="1">
                      <rect width="30" height="30" rx="15" stroke="none"></rect>
                      <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" fill="none"></rect>
                    </g>
                  </g>
                  <g id="conversion" transform="translate(567.976 210.905)">
                    <path id="Path_13963" data-name="Path 13963"
                      d="M13.474,6.51H1V5.376H12.1l-3.4-3.4.8-.8,4.37,4.37a.567.567,0,0,1-.4.968Z"
                      transform="translate(-1 -1.172)" fill="#031219"></path>
                    <path id="Path_13964" data-name="Path 13964"
                      d="M5.536,33.338l-4.37-4.37a.567.567,0,0,1,.4-.968H14.041v1.134H2.936l3.4,3.4Z"
                      transform="translate(-1 -20.395)" fill="#031219"></path>
                  </g>
                </g>
              </svg></button>
            </div>

            <div class="d-flex justify-content-center align-items-center flex-column  w-50">

              <div>
                <span class="text-white">Licve Account</span>

              </div>
              <div>
                <span class="text-white fs-3">0</span>
              </div>
            </div>
          </div>
          <div class="modal-exchange-body hidden-desktop">

            <div class="content d-flex flex-column align-items-center  px-3 py-5 w-100">
              <div class="inputGroup mb-3 w-100  d-flex  borderBtSecondary2">
                <div class="w-60">
                  <input ref={inputRef} type="number" placeholder="Please enter transfer amount" aria-label="Recipient's username"
                    aria-describedby="button-addon2" class="form-control w-100 border-unset bg-unset text-white" />
                </div>

                <div class="w-40 d-flex justify-content-end align-items-center  ">
                  <div class="icon-circel me-1">
                    <img src={`${routeLink.domain}/assets/imgs/icon-usdt.f667059b.svg`} alt="" class="w-100 h-100 object-fit-cover" />
                  </div>
                  {/* <div class=" h-100 d-flex justify-content-center align-items-center boder-left-main">
                    <button type="button" id="button-addon2" class="btn text-success fw-bold" onClick={()=>setAllBalance(1)}>All</button>
                  </div> */}
                </div>


              </div>
              <div class="textGuide color-light-gray d-none">
                You can only trade when assets are transferred to the corresponding account. Transfers between accounts are fee of charge.

              </div>
              <button class="button btn-border-radius btnMainBorder fix-bottom btn-large primary w-75 font-weight-bold" onClick={withdraw_}>
                withdraw    {isLoading == 2 && <Loading style={{ width: "20px", height: "20px" }} />}
              </button>
            </div>
          </div>

        </div>
      </Modal>
      <Modal show={showModalDeposit} setHide={setShowModalDeposit} >

        <div class="modal-exchange bg-body position-relative h-50 ">

          {/* <div class="modal-title d-flex justify-content-between align-items-center px-2 py-2 hidden-desktop">
    <h1 class="text-white">Chuyển tiền</h1>
    <button class="bg-unset border-unset"><i class="fas fa-times text-white"></i></button>
  </div> */}
          <div class="modal-exchange-top d-flex bgSecondary4 w-100 d-none">
            <div
              class="d-flex justify-content-center align-items-center flex-column  w-50 position-relative boder-right-main p-4 ">
              <div class="d-flex justify-content-center align-items-center">
                <span class="colorPrimary fs-4">USD</span>
                <span class="text-white ms-1">wallet</span>
              </div>
              <div>
                <span class="text-white fs-3">0</span>
              </div>


              <button class="btn-exchange bg-unset border-unset position-absolute"><svg xmlns="http://www.w3.org/2000/svg"
                width="30" height="30" viewBox="0 0 30 30" class="iconTransfer">
                <g id="Group_10897" data-name="Group 10897" transform="translate(-559.431 -202.553)">
                  <g id="Group_4613" data-name="Group 4613" transform="translate(559.431 202.553)">
                    <g id="Rectangle_2919" data-name="Rectangle 2919" transform="translate(0)" fill="#e9f0fa"
                      stroke="#e5e5e5" stroke-width="1">
                      <rect width="30" height="30" rx="15" stroke="none"></rect>
                      <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" fill="none"></rect>
                    </g>
                  </g>
                  <g id="conversion" transform="translate(567.976 210.905)">
                    <path id="Path_13963" data-name="Path 13963"
                      d="M13.474,6.51H1V5.376H12.1l-3.4-3.4.8-.8,4.37,4.37a.567.567,0,0,1-.4.968Z"
                      transform="translate(-1 -1.172)" fill="#031219"></path>
                    <path id="Path_13964" data-name="Path 13964"
                      d="M5.536,33.338l-4.37-4.37a.567.567,0,0,1,.4-.968H14.041v1.134H2.936l3.4,3.4Z"
                      transform="translate(-1 -20.395)" fill="#031219"></path>
                  </g>
                </g>
              </svg></button>
            </div>

            <div class="d-flex justify-content-center align-items-center flex-column  w-50">

              <div>
                <span class="text-white">Licve Account</span>

              </div>
              <div>
                <span class="text-white fs-3">0</span>
              </div>
            </div>
          </div>
          <div class="modal-exchange-body hidden-desktop">

            <div class="content d-flex flex-column align-items-center  px-3 py-5 w-100">
              <div class="inputGroup mb-3 w-100  d-flex  borderBtSecondary2">
                <div class="w-60">
                  <input ref={inputRef2} type="number" placeholder="Please enter transfer amount h-100" class="form-control w-100 border-unset bg-unset text-white" />
                </div>

                <div class="w-40 d-flex justify-content-end align-items-center  ">
                  <div class="icon-circel me-1">
                    <img src={`${routeLink.domain}/assets/imgs/icon-usdt.f667059b.svg`} alt="" class="w-100 h-100 object-fit-cover" />
                  </div>
                  <div class=" h-100 d-flex justify-content-center align-items-center boder-left-main">
                    <button type="button" id="button-addon2" class="btn text-success fw-bold" onClick={()=>setAllBalance(2)}>All</button>
                  </div>
                </div>


              </div>
              <div class="textGuide color-light-gray d-none">
                You can only trade when assets are transferred to the corresponding account. Transfers between accounts are fee of charge.

              </div>
              <button class="button btn-border-radius btnMainBorder fix-bottom btn-large primary w-75 font-weight-bold" onClick={deposit_}>
                Deposit    {isLoading == 4 && <Loading style={{ width: "20px", height: "20px" }} />}
              </button>
            </div>
          </div>

        </div>
      </Modal>
    </div>
  )
}

export default Index;
